import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { NetworkStatusService } from 'app/core/services/network-status.service';

@Component({
  selector: 'app-network-status-banner',
  templateUrl: './network-status-banner.component.html',
  styleUrl: './network-status-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NetworkStatusBannerComponent {

  private readonly _transloco = inject(TranslocoService);

  readonly networkStatus = inject(NetworkStatusService);

  readonly message = computed(() => {
    const status = this.networkStatus.status();

    return status ? this._transloco.translate(`network-status.${status}`) : '';
  });

}
